export const FeatureFlags = {
  NewJobBook: 'new-jobbook',
  NewEditJob: 'new-edit-job',
  OldPoReport: 'old-po-report',
  UseLegacyInvoiceApproval: 'use-legacy-invoice-approval'
};
